import {
  Component,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { PaginatorState } from 'primeng/paginator';
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
  host: {
    class: 'relative flex items-center min-h-14',
  },
})
export class PaginatorComponent {
  pageChange = output<PaginatorState>();
  first = input<number | undefined>(undefined);
  rows = input(10);
  totalRecords = input.required<number>();
  paginatorState = signal<PaginatorState>({
    first: 0,
    page: 0,
    pageCount: 0,
    rows: 0,
  });
  currentFirst = computed(() => {
    const inputFirst = this.first();
    if (inputFirst !== undefined) {
      return inputFirst;
    }
    return this.paginatorState().first ?? 0;
  });
  startInterval = computed(() => {
    if (this.totalRecords() === 0) {
      return 0;
    }
    return this.currentFirst() + 1;
  });
  endInterval = computed(() => {
    if (this.totalRecords() === 0) {
      return 0;
    }
    const endInterval = this.currentFirst() + this.rows();
    return endInterval > this.totalRecords()
      ? this.totalRecords()
      : endInterval;
  });

  constructor() {
    effect(() => {
      const first = this.first();
      if (first === undefined) return;
      const rows = this.rows();
      const totalRecords = this.totalRecords();
      const page = rows ? Math.floor(first / rows) : 0;
      const pageCount = rows ? Math.ceil(totalRecords / rows) : 0;
      this.paginatorState.set({
        first,
        page,
        pageCount,
        rows,
      });
    });
  }

  onPageChange(event: PaginatorState) {
    this.paginatorState.set(event);
    this.pageChange.emit(event);
  }
}
